export default "__VITE_ASSET__B0su_64___"